import { provideZoneChangeDetection } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import * as Sentry from '@sentry/angular';
import { environment } from './environments/environment';

const env = environment;

Sentry.init({
  dsn: env.sentryDns,
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration({
      maskAllText: true,
      blockAllMedia: true,
    }),
  ],
  environment: env.production ? 'production' : 'development',
  release: env.release,
  enabled: env.sentryEnabled,
  tracesSampleRate: 1.0,
  tracePropagationTargets: ['localhost', env.baseApiUrl],
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
});

bootstrapApplication(AppComponent, {
  ...appConfig,
  providers: [provideZoneChangeDetection(), ...appConfig.providers],
  // eslint-disable-next-line no-console
}).catch((err) => console.error(err));
